import type { HeaderScan } from "./types";

export const sampleScan: HeaderScan = {
  requestedUrl: "https://example.com",
  finalUrl: "https://example.com/",
  hostname: "example.com",
  checkedAt: "2026-06-14T00:00:00.000Z",
  score: 72,
  scoreLabel: "Needs tightening",
  fetch: {
    requestedUrl: "https://example.com",
    finalUrl: "https://example.com/",
    hostname: "example.com",
    status: 200,
    ok: true,
    contentType: "text/html; charset=utf-8",
    elapsedMs: 184,
    error: ""
  },
  headers: [
    { name: "content-security-policy", value: "default-src 'self'; script-src 'self'; object-src 'none'; base-uri 'self'; frame-ancestors 'self'" },
    { name: "strict-transport-security", value: "max-age=31536000; includeSubDomains" },
    { name: "x-content-type-options", value: "nosniff" },
    { name: "referrer-policy", value: "strict-origin-when-cross-origin" },
    { name: "permissions-policy", value: "camera=(), microphone=(), geolocation=()" }
  ],
  checks: [
    {
      key: "csp",
      label: "Content-Security-Policy",
      level: "pass",
      value: "default-src 'self'; script-src 'self'; object-src 'none'",
      detail: "Policy is enforced and includes baseline XSS and embedding controls.",
      points: 22
    },
    {
      key: "hsts",
      label: "Strict-Transport-Security",
      level: "pass",
      value: "max-age=31536000; includeSubDomains",
      detail: "HTTPS persistence is active for one year.",
      points: 16
    },
    {
      key: "xcto",
      label: "X-Content-Type-Options",
      level: "pass",
      value: "nosniff",
      detail: "MIME sniffing protection is enabled.",
      points: 10
    },
    {
      key: "referrer",
      label: "Referrer-Policy",
      level: "pass",
      value: "strict-origin-when-cross-origin",
      detail: "Cross-origin referrers are limited to origin.",
      points: 9
    },
    {
      key: "permissions",
      label: "Permissions-Policy",
      level: "warn",
      value: "camera=(), microphone=(), geolocation=()",
      detail: "Core sensors are disabled, but payment and USB are not declared.",
      points: 5
    },
    {
      key: "coop",
      label: "Cross-Origin-Opener-Policy",
      level: "info",
      value: "Not present",
      detail: "Useful for stronger browsing-context isolation on app-like sites.",
      points: 0
    }
  ],
  csp: {
    present: true,
    reportOnly: false,
    directives: [
      { name: "default-src", value: "'self'", level: "pass", detail: "Limits unspecified resources to same origin." },
      { name: "script-src", value: "'self'", level: "pass", detail: "Scripts are limited to same origin." },
      { name: "object-src", value: "'none'", level: "pass", detail: "Legacy plugin content is disabled." },
      { name: "base-uri", value: "'self'", level: "pass", detail: "Base URL injection risk is reduced." },
      { name: "frame-ancestors", value: "'self'", level: "pass", detail: "Cross-origin embedding is limited." }
    ],
    riskyTokens: []
  },
  issues: [
    {
      level: "warn",
      title: "Add broader Permissions-Policy coverage",
      detail: "Declare payment and USB if this site does not need them.",
      header: "Permissions-Policy"
    },
    {
      level: "info",
      title: "Consider COOP for app-like pages",
      detail: "Cross-Origin-Opener-Policy can reduce opener-based cross-origin risk.",
      header: "Cross-Origin-Opener-Policy"
    }
  ],
  generated: {
    cloudflare: `/*
  Strict-Transport-Security: max-age=31536000; includeSubDomains; preload
  X-Content-Type-Options: nosniff
  Referrer-Policy: strict-origin-when-cross-origin
  Permissions-Policy: camera=(), microphone=(), geolocation=(), payment=(), usb=()
  Content-Security-Policy: default-src 'self'; script-src 'self'; style-src 'self'; img-src 'self' data: https:; font-src 'self'; object-src 'none'; base-uri 'self'; frame-ancestors 'self'; form-action 'self'; upgrade-insecure-requests
  Cross-Origin-Opener-Policy: same-origin
  Cross-Origin-Resource-Policy: same-origin`,
    nginx: `add_header Strict-Transport-Security "max-age=31536000; includeSubDomains; preload" always;
add_header X-Content-Type-Options "nosniff" always;
add_header Referrer-Policy "strict-origin-when-cross-origin" always;
add_header Permissions-Policy "camera=(), microphone=(), geolocation=(), payment=(), usb=()" always;
add_header Content-Security-Policy "default-src 'self'; script-src 'self'; style-src 'self'; img-src 'self' data: https:; font-src 'self'; object-src 'none'; base-uri 'self'; frame-ancestors 'self'; form-action 'self'; upgrade-insecure-requests" always;`,
    netlify: `/*
  Strict-Transport-Security: max-age=31536000; includeSubDomains; preload
  X-Content-Type-Options: nosniff
  Referrer-Policy: strict-origin-when-cross-origin
  Permissions-Policy: camera=(), microphone=(), geolocation=(), payment=(), usb=()
  Content-Security-Policy: default-src 'self'; script-src 'self'; style-src 'self'; img-src 'self' data: https:; font-src 'self'; object-src 'none'; base-uri 'self'; frame-ancestors 'self'; form-action 'self'; upgrade-insecure-requests`,
    markdown: `# HeaderHarden report for example.com

Score: 72/100

## Fix first
- Add broader Permissions-Policy coverage.
- Consider Cross-Origin-Opener-Policy for app-like pages.

Generated by HeaderHarden Studio.`
  },
  summary: {
    passes: 4,
    warnings: 1,
    failures: 0,
    informational: 1
  }
};
